// src/Components/Cadastro/ImportProducts/ListaImportProducts.tsx
import { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { IListImportProducts } from '../../../Pages/Cadastro/CadImportProducts';
import LayoutFilter from '../../data/LayoutFilter';
import { FaFileExcel, FaStore, FaUpload, FaInfoCircle } from 'react-icons/fa';
import { useAppSelector } from '../../../redux/store';
import * as S from './styled';

export default function ListaImportProducts({
  OnAddNewImport,
  title,
}: IListImportProducts) {
  const storeMe = useAppSelector(({ storeMeReducer }) => storeMeReducer.value);
  const [openFilter, setOpenFilter] = useState<boolean>(false);

  const handleAdd = () => {
    OnAddNewImport(true);
  };

  const onClickOpenFilter = () => {
    setOpenFilter(!openFilter);
  };

  return (
    <>
      <LayoutFilter
        title={title}
        onClickAdd={handleAdd}
        onClickOpenFilter={onClickOpenFilter}
        openFilter={openFilter}
      >
        <S.Wrapper>
          {openFilter && (
            <div className="min-screen">
              <div style={{ padding: '15px' }}>
                <p style={{ color: '#6c757d', fontSize: '14px', margin: '0' }}>
                  Configure os filtros para buscar importações específicas
                </p>
              </div>
            </div>
          )}

          <div className="max-screen">
            <div style={{ padding: '15px' }}>
              <p style={{ color: '#6c757d', fontSize: '14px', margin: '0' }}>
                Configure os filtros para buscar importações específicas
              </p>
            </div>
          </div>
        </S.Wrapper>
      </LayoutFilter>

      {/* Informações da Loja - Simplificada */}
      <div 
        className="containerFilter" 
        style={{ 
          backgroundColor: '#f8f9fa',
          border: '1px solid #dee2e6',
          marginBottom: '25px'
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          <FaStore style={{ fontSize: '24px', color: '#007bff' }} />
          <div>
            <h3 style={{ 
              fontSize: '18px', 
              fontWeight: '600', 
              margin: '0 0 5px 0',
              color: '#495057'
            }}>
              {storeMe?.storeActive?.name || 'Loja Não Identificada'}
            </h3>
            <div style={{ fontSize: '14px', color: '#6c757d' }}>
              ID: #{storeMe?.storeActive?.id || 'N/A'}
            </div>
          </div>
        </div>
      </div>

      {/* Botão Principal de Importação */}
      <Row style={{ marginBottom: '20px' }}>
        <Col md={12}>
          <div 
            className="containerFilter" 
            style={{ 
              backgroundColor: '#fff',
              border: '3px solid #28a745',
              borderRadius: '12px',
              textAlign: 'center',
              padding: '40px 20px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
            }}
            onClick={handleAdd}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#f8fff9';
              e.currentTarget.style.transform = 'translateY(-3px)';
              e.currentTarget.style.boxShadow = '0 8px 25px rgba(40, 167, 69, 0.25)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#fff';
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            <FaUpload style={{ 
              fontSize: '64px', 
              color: '#28a745', 
              marginBottom: '20px' 
            }} />
            <h2 style={{ 
              fontSize: '28px', 
              color: '#28a745', 
              marginBottom: '15px',
              fontWeight: '700'
            }}>
              Importar Produtos
            </h2>
            <p style={{ 
              fontSize: '16px', 
              color: '#6c757d', 
              margin: '0 0 15px 0',
              lineHeight: '1.5'
            }}>
              Envie sua planilha Excel com os produtos e categorias
            </p>
            <div style={{ 
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '15px',
              marginTop: '20px'
            }}>
              <div style={{ 
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                backgroundColor: '#e8f5e9',
                padding: '8px 16px',
                borderRadius: '20px',
                fontSize: '14px',
                color: '#28a745',
                fontWeight: '600'
              }}>
                <FaFileExcel />
                .xlsx
              </div>
              <div style={{ 
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                backgroundColor: '#e8f5e9',
                padding: '8px 16px',
                borderRadius: '20px',
                fontSize: '14px',
                color: '#28a745',
                fontWeight: '600'
              }}>
                <FaFileExcel />
                .xls
              </div>
            </div>
          </div>
        </Col>
      </Row>

      {/* Informações Essenciais */}
      <div 
        className="containerFilter" 
        style={{ 
          backgroundColor: '#d1ecf1', 
          border: '1px solid #bee5eb',
          borderRadius: '8px'
        }}
      >
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px' }}>
          <FaInfoCircle style={{ 
            color: '#0c5460', 
            marginTop: '3px', 
            fontSize: '18px' 
          }} />
          <div>
            <h4 style={{ 
              color: '#0c5460', 
              marginBottom: '10px', 
              fontSize: '16px',
              fontWeight: '600'
            }}>
              Requisitos do Arquivo
            </h4>
            <ul style={{ 
              fontSize: '14px', 
              color: '#0c5460', 
              paddingLeft: '20px', 
              margin: '0',
              lineHeight: '1.6'
            }}>
              <li>Arquivo Excel (.xlsx ou .xls) até 10MB</li>
              <li>Colunas obrigatórias: Nome, Código, Categoria, Preço</li>
              <li>Não use células mescladas ou formatação especial</li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}